import { useQuery } from "@tanstack/react-query";

import { getPages } from "../../api/Pages";

export const usePages = (themeId: number) => {
  return useQuery({ queryKey: ["pages", themeId], queryFn: () => getPages(themeId) });
};
